import { connect } from 'react-redux'
import { withNamespaces } from 'react-i18next'
import { memo, useState } from 'react'
import { Row, Col, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap'
import RiskMatrix from '../../../../../components/charts/RiskMatrix'
import SingleDonutChart from '../../../../../components/charts/SingleDonutChart'
import BarChart from '../../../../../components/charts/barchart'
import { withRouter } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useQuery } from '@tanstack/react-query'
import RiskManagementService from '../../../../../api/RiskManagementService'
import { 
    ModulesApiRoutes
} from 'src/modules/risk-management/drivers'

const RiskMatrixContainer = ({ t, isLoading, overViewData }) => {
    const [activeTab, setActiveTab] = useState('current');

    return (
        <div>
            <Nav tabs>
                <NavItem>
                    <NavLink
                        className={activeTab === 'current' ? 'active' : ''}
                        onClick={() => setActiveTab('current')}
                    >
                        {t('Current Risks')}
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        className={activeTab === 'residual' ? 'active' : ''}
                        onClick={() => setActiveTab('residual')}
                    >
                        {t('Residual Risks')}
                    </NavLink>
                </NavItem>
            </Nav>
            <TabContent activeTab={activeTab} className='p-2'>
                <TabPane tabId="current">
                    <Row>
                        <Col sm="12">
                            <RiskMatrix
                                risksKey="risks"
                                matrix={overViewData?.riskMatrix?.matrix}
                                consequences={
                                    overViewData?.riskMatrix?.consequences
                                }
                                currency={overViewData?.riskMatrix?.currency}
                                likelihoods={overViewData?.riskMatrix?.likelihoods}
                                risks={null}
                                ratings={overViewData?.riskMatrix?.ratings}
                            />
                        </Col>
                    </Row>
                </TabPane>
                <TabPane tabId="residual">
                    <Row>
                        <Col sm="12">
                            <RiskMatrix
                                risksKey="residualRisks"
                                matrix={overViewData?.riskMatrix?.matrix}
                                consequences={
                                    overViewData?.riskMatrix?.consequences
                                }
                                currency={overViewData?.riskMatrix?.currency}
                                likelihoods={overViewData?.riskMatrix?.likelihoods}
                                risks={null}
                                ratings={overViewData?.riskMatrix?.ratings}
                            />
                        </Col>
                    </Row>
                </TabPane>
            </TabContent>
        </div>
    )
}

const AnalystView = ({ t, Modules }) => {
    const routes = ModulesApiRoutes[Modules.active]

    const riskService = new RiskManagementService(routes.API_BASE_URL)

    const {
        data: overViewData = [],
        isFetching: fetchingInprocess
    } = useQuery({
        queryKey: ['risk-managment-overView'],
        queryFn: async () => {
            return await riskService.fetchOverview()
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: () => {
            toast(
                t(
                    'An error occurred while fetching risk mangment information.'
                ),
                {
                    type: 'error'
                }
            )
        }
    })

    return (
        <div>
            <Row>
                <Col className='mt-3' sm='12' md='12' lg='12'>
                    <div className='risk-managment-card'>
                        <RiskMatrixContainer
                            t={t}
                            overViewData={overViewData}
                            isLoading={fetchingInprocess}
                        />
                    </div>
                </Col>
            </Row>

            <Row>
                <Col className='mt-4' sm='12' md='4'>
                    <div className='risk-managment-card'>
                        <SingleDonutChart
                            title={t('Risks created')}
                            riskCreated={overViewData.riskCreated}
                        />
                    </div>
                </Col>
                <Col className='mt-4' sm='12' md='4'>
                    <div className='risk-managment-card'>
                        <SingleDonutChart
                            title={t('Mitigation tasks')}
                            mitigation={overViewData.mitigationTasks}
                        />
                    </div>
                </Col>
                <Col className='mt-4' sm='12' md='4'>
                    <div className='risk-managment-card'>
                        <BarChart
                            createdRisksAndTasks={
                                overViewData?.createdRisksAndTasks
                            }
                        />
                    </div>
                </Col>
            </Row>
        </div>
    )
}

const mapToState = (state) => {
    const { Modules } = state

    return {
        Modules
    }
}

export default withNamespaces()(
    withRouter(
        connect(mapToState)(
            memo(AnalystView)
        )
    )
)
